{
    "welcome-to": "Hoş geldiniz",
    "copyright": "Telif Hakkı",
    "trademarks": "Tüm ticari markalar veya tescilli ticari markalar, ilgili sahiplerinin mülkiyetindedir.",

    "menu-profile": "Profil",
    "menu-logout": "Çıkış Yap",
    "menu-home": "Ana Sayfa",
    "menu-dashboard": "Gösterge Paneli",
    "menu-machines": "Makineler",
    "menu-colaboration": "İş Birliği",
    "menu-administration": "Yönetim",
    "menu-machine": "Makine",
    "menu-list": "Liste",
    "menu-service-data": "Servis Verileri",
    "menu-trash": "Çöp Kutusu",

    "machine-info": "Makine bilgisi",
    "medium": "Orta",
    "machine-activity": "Makine aktivitesi",
    "machine-part-info": "Makine parçası bilgisi",
    "name": "Ad",
    "version": "Sürüm",
    "owner": "Sahip",
    "state": "Durum",
    "actions": "Eylemler",
    "kind": "Tür",
    "description": "Açıklama",
    "size": "Boyut",
    "last-write": "Son yazma",
    "ver": "Sür.",
    "restore": "Geri Yükle",
    "when": "Ne zaman",
    "type": "Tür",
    "level": "Seviye",
    "text": "Metin",
    "tags": "Etiketler",
    "part-type": "Parça türü",
    "firmware-version": "Yazılım sürümü",
    "model": "Model",
    "created": "Oluşturuldu",
    "modified": "Değiştirildi",
    "status": "Durum",
    "loading": "Yükleniyor",
    "fv": "F.s.",
    "remove": "Kaldır",
    "user": "Kullanıcı",
    "fenix-version": "Fenix sürümü",
    "service-data-remove-question": "Bu servis verilerini silmek istediğinizden emin misiniz?",
    "save-as-duplicate": "Kopya olarak kaydet",
    "upload-file": "Dosya yükle",
    "restore-machine-data-from-backup": "Yedekten makine verilerini geri yükle",
    "you-want-to-change-owner": "Sahibi değiştirmek istiyor musunuz?",
    "choose-file": "Dosya seç",
    "detail": "Detay",
    "yes": "Evet",
    "no": "Hayır",
    "machine-detail-remove-question": "Bu makineyi silmek istediğinizden emin misiniz?",
    "status-auto-update": "Durum otomatik güncelleme",
    "download": "İndir",
    "copy": "Kopyala",
    "move": "Taşı",
    "change-owner": "Sahibi değiştir",
    "new-machine-name": "Yeni makine adı",
    "submit": "Gönder",
    "set-as-current": "Mevcut olarak ayarla",
    "checkout": "Ödeme",
    "base-data": "Temel veriler",
    "part-structure-type": "Parça yapı türü",
    "owner-id": "Sahip Kimliği",
    "parent-id": "Ana Kimlik",
    "part-class-type": "Parça sınıfı türü",
    "errors": "Hatalar",
    "generic-device": "Genel cihaz",
    "device-model": "Cihaz modeli",
    "address": "Adres",
    "camera-info": "Kamera bilgisi",
    "sensor-model": "Sensör modeli",
    "slides-in-view": "Görünümdeki slaytlar",
    "slider-info": "Kaydırıcı bilgisi",
    "channels": "Kanallar",
    "shot-stats-from": "Çekim istatistikleri - başlangıç",
    "shot-stats-to": "Çekim istatistikleri - bitiş",
    "shot-stats-counter": "Çekim istatistikleri sayacı",
    "shot-stats": "Çekim istatistikleri",
    "slider": "Kaydırıcı",
    "valve": "Valf",
    "number-shots": "Çekim sayısı",
    "custom": "Özel",
    "move-machine": "Makinayı taşı",
    "machine-is-not-selected": "Makine seçilmedi.",
    "machine-successfully-deleted": "Makine başarıyla silindi.",
    "failed-to-delete-machine": "Makine silinemedi.",
    "failed-to-backup-machine": "Makine yedeklenemedi.",
    "owner-successfully-changed": "Sahip başarıyla değiştirildi.",
    "failed-to-change-owner": "Sahip değiştirilemedi.",
    "machine-successfully-copied": "Makine başarıyla kopyalandı.",
    "failed-to-copy-machine": "Makine kopyalanamadı.",
    "machine-successfully-moved": "Makine başarıyla taşındı.",
    "failed-to-move-machine": "Makine taşınamadı.",
    "machine-set-as-current": "Makine mevcut olarak ayarlandı.",
    "install-app-question": "3U Vision Cloud uygulamasını yüklemek ister misiniz?",
    "install": "Yükle",
    "cancel": "İptal",
    "install-application": "Uygulamayı yükle",
    "step": "Adım",
    "tap-share-icon": "Paylaş simgesine dokunun.",
    "scroll-down-and-tap": "Paylaş menüsünde aşağı kaydırın ve dokunun",
    "add-to-home-screen": "Ana ekrana ekle",
    "you-will-be-propted": "Uygulamaya bir ad vermeniz istenecek. Varsayılan adı tutabilir veya istediğiniz gibi değiştirebilirsiniz. Ardından, dokunun",
    "add": "Ekle",
    "in-top-right-corner": "sağ üst köşede",
    "do-not-show-again": "Tekrar gösterme",
    "you-are-offline": "Çevrimdışısınız.",
    "app-can-not-work-offline": "Uygulama çevrimdışı çalışamaz.",
    "please-check-your-internet-connection": "Lütfen internet bağlantınızı kontrol edin.",
    "unexpected-server-version": "Beklenmeyen sunucu sürümü.",
    "current-is": "Mevcut olan",
    "and-expected": "ve beklenen",
    "application-version-is": "Uygulama sürümü",
    "new-version-available": "Yeni sürüm mevcut",
    "do-you-want-to-install": "Yüklemek istiyor musunuz?",
    "delete-confirmation": "Silme onayı",
    "machine-medium-remove-question": "Ortamı silmek istediğinizden emin misiniz?",
    "machine-medium-checkout-error": "Makine ortamı çıkarılamadı.",
    "invalid-data": "Geçersiz veri.",
    "failed-to-load-messages": "Mesajlar yüklenemedi.",
    "failed-to-save-board": "Pano kaydedilemedi.",
    "failed-to-delete-board": "Pano silinemedi.",
    "machine-structure-caption": "Yapı",
    "machine-structure-value-caption": "Değer",
    "machine-structure-not-available" : "Makine yapısı mevcut değil",
    "machines-upload-file-upload-in-progress": "Dosya yükleme işlemi devam ediyor.",
    "upload-success": "Yükleme başarılı."
  }
